import React, { useState } from 'react'
import styled from 'styled-components'
import Typography from '@ntuctech/devex-tangram/Typography'
import { Radio } from '@ntuctech/devex-tangram'
import { QuickBuySgovIcon } from '@ntuctech/tangram-web'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import SvgAlert from '@ntuctech/devex-tangram/Icon/SvgAlert'

import {
  ADD_GOV_AGENCY,
  SELECT_AGENCY,
  PURCHASE_REASON_EMPTY,
} from '../../../utils/constants/payments'

import Text from '../../Text'
import { TextArea } from '../../Input/Input'
import alert from '../../icons/svg/alert.svg'

const Footer = styled.div`
  display: flex;
  margin-top: 1.25rem;
`
const StyledContinueButtonContainer = styled.div`
  margin-left: auto;
  button {
    min-width: auto !important;
  }
`
const QuickBuyBox = styled.div``
const AddGovAgencyTitle = styled(Typography)`
  color: #1454b8;
  margin-top: 1.25rem;
  cursor: pointer;
`
const PurchaseReasonInput = styled.div`
  margin-top: 1.25rem;
`
const CorpBillingMethodSelectionContainer = styled.div``
const StyledUl = styled.ul`
  width: 100%;
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
  max-height: calc(
    4.1rem *
      ${({ isShownAll, maximumQuantity, listLength }) =>
        listLength > maximumQuantity && isShownAll
          ? listLength
          : listLength < maximumQuantity
          ? listLength
          : maximumQuantity}
  );
  transition: max-height 0.5s ease-out;
`
const StyledLi = styled.li`
  border-style: solid;
  border-width: 1px;
  border-color: ${({ isActive }) => (isActive ? '#1557bf' : '#eaeaea')};
  background: ${({ isActive }) => (isActive ? 'rgb(232, 240, 253)' : '#fff')};
  cursor: pointer;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  width: 100%;
`
const CorpBillingItemContainer = styled.div`
  display: flex;
  align-items: center;
  height: 1.5rem;
  justify-content: space-between;
  padding: 1rem 0;
`
const AgencyNotSelectedErrorBox = styled.div`
  margin-bottom: 0.75rem;
  display: flex;
  background: #fee7ed;
  font-size: 1rem;
  padding: 1rem;
  text-align: center;
`
const AgencyNotSelectedErrorMessage = styled.div`
  padding: 0.25rem;
`
const PurchaseReasonEmptyErrorBox = styled.div`
  margin-bottom: 0.75rem;
  display: flex;
  font-size: 1rem;
  text-align: center;
  color: #c10b3a;
  font-weight: 600;
`
const AlertImg = styled.img`
  overflow: hidden;
`
const QuickBuyHome = ({
  onAddGovAgency,
  hasCorpBillingSetup,
  agenciesList,
  onSubmit,
}) => {
  const getInitialSelectedCorpBillingState = () =>
    agenciesList.length === 1 ? agenciesList[0] : {}
  const [purchaseReason, setPurchaseReason] = useState('')
  const [selectedCorpBilling, setSelectedCorpBilling] = useState(
    getInitialSelectedCorpBillingState
  )
  const [agencyNotSelected, setAgencyNotSelected] = useState(false)
  const [purchaseReasonEmpty, setPurchaseReasonEmpty] = useState(false)

  const handleWordCount = React.useCallback(e => {
    setPurchaseReason(e.target.value)
  }, [])

  const handleSelect = React.useCallback(selectedCorpbilling => {
    setSelectedCorpBilling(selectedCorpbilling)
    setAgencyNotSelected(false)
  }, [])

  return (
    <QuickBuyBox>
      {agencyNotSelected && (
        <AgencyNotSelectedErrorBox>
          <SvgAlert size="m" color="#FF0000" />
          <AgencyNotSelectedErrorMessage>
            {' '}
            {SELECT_AGENCY}
          </AgencyNotSelectedErrorMessage>
        </AgencyNotSelectedErrorBox>
      )}
      {hasCorpBillingSetup && (
        <CorpBillingMethodSelectionContainer>
          <StyledUl>
            {agenciesList.map(corpbilling => (
              <StyledLi
                isActive={
                  selectedCorpBilling &&
                  corpbilling.id === selectedCorpBilling.id
                }
                key={corpbilling.id}
                data-key={corpbilling.id}
                data-testid={corpbilling.id}
                role="button"
                onClick={() => handleSelect(corpbilling)}
              >
                <CorpBillingItemContainer>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <QuickBuySgovIcon width="3rem" height="3rem" />
                    <div style={{ marginLeft: '0.5rem' }}>
                      <Text size="medium" weight="bold">
                        <p>{corpbilling.corpLongName}</p>
                      </Text>
                      <Text size="medium">
                        <p>{corpbilling.buyerCorpEmail}</p>
                      </Text>
                    </div>
                  </div>

                  <Radio
                    isActive={
                      selectedCorpBilling &&
                      corpbilling.id === selectedCorpBilling.id
                    }
                    checked={
                      selectedCorpBilling &&
                      corpbilling.id === selectedCorpBilling.id
                    }
                    name="corporateBilling"
                    id={corpbilling.id}
                    readOnly
                  />
                </CorpBillingItemContainer>
              </StyledLi>
            ))}
          </StyledUl>
          <AddGovAgencyTitle variant="h5" onClick={onAddGovAgency}>
            {ADD_GOV_AGENCY}
          </AddGovAgencyTitle>
          <PurchaseReasonInput>
            <Text color="#696969" size="medium" weight="bold">
              Reason for purchase
            </Text>
            <TextArea
              name="quickBuyPurchaseReason"
              value={purchaseReason}
              maxLength={100}
              onChange={handleWordCount}
              testId="purchaseReasonTxtArea"
              placeholder="e.g. Top-up inventory for HR department"
            />
            {purchaseReasonEmpty && (
              <PurchaseReasonEmptyErrorBox>
                <AlertImg src={alert} />
                <AgencyNotSelectedErrorMessage>
                  {' '}
                  {PURCHASE_REASON_EMPTY}
                </AgencyNotSelectedErrorMessage>
              </PurchaseReasonEmptyErrorBox>
            )}
          </PurchaseReasonInput>
        </CorpBillingMethodSelectionContainer>
      )}
      <Footer>
        <NdsThemeProvider>
          <StyledContinueButtonContainer>
            <ButtonContained
              compact
              size="l"
              onClick={() => {
                if (Object.keys(selectedCorpBilling).length === 0) {
                  setAgencyNotSelected(true)
                }
                if (purchaseReason === '') {
                  setPurchaseReasonEmpty(true)
                }
                if (
                  Object.keys(selectedCorpBilling).length !== 0 &&
                  purchaseReason !== ''
                ) {
                  onSubmit(
                    {
                      corpBillingId: selectedCorpBilling.id,
                      corpBillingName: selectedCorpBilling.corpLongName,
                      corpBillingEmail: selectedCorpBilling.buyerCorpEmail,
                    },
                    purchaseReason
                  )
                }
              }}
              data-testid="quickbuy-continue-button"
            >
              Continue
            </ButtonContained>
          </StyledContinueButtonContainer>
        </NdsThemeProvider>
      </Footer>
    </QuickBuyBox>
  )
}
export default QuickBuyHome
